// extracted by mini-css-extract-plugin
export var label = "_4u-1";
export var reminder = "_4u-0";